import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React from 'react';

type PageHeaderSubtitleProps = {
  children: React.ReactNode;
};

const styles = {
  pageHeaderSubtitle: {
    color: (theme: Theme) => theme.palette?.primary.light,
    fontWeight: '600',
    margin: 0,
    padding: { xs: '15px 10px 5px 4px', md: '15px 10px 5px 6px', xl: '15px 10px 5px 20px' },
    fontSize: { xs: '12px', md: '14px', xl: '16px' },
  },
};

function PageHeaderSubtitle({ children }: PageHeaderSubtitleProps) {
  return (
    <Typography variant="h4" sx={styles.pageHeaderSubtitle}>
      {children}
    </Typography>
  );
}

export default PageHeaderSubtitle;
